import React from 'react';

export function Lightbox({ src, onClose }) {
  return (
    <div
      className="fixed inset-0 z-[9998] bg-black/[0.94] flex items-center justify-center transition-opacity duration-400"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-6 right-6 w-11 h-11 bg-white/10 border-none rounded-full text-white cursor-pointer text-xl flex items-center justify-center transition-colors duration-300 hover:bg-nestlent-green"
      >
        ✕
      </button>
      <img
        src={src}
        alt="Full view"
        className="max-w-[90vw] max-h-[90vh] object-contain rounded-sm"
        onClick={e => e.stopPropagation()}
      />
    </div>
  );
}
